import React from 'react';

const VectorLoader = ({ progress, className }) => {
  return (
    <div className={`vector-loader ${className}`}>
      <div
        className={`loading-bar ${progress === 100 ? 'complete' : ''}`}
        style={{
          width: `${progress}%`,
        }}
      ></div>
    </div>
  );
};

export default VectorLoader;
